module.exports = __webpack_public_path__ + "static/media/eth-round-landing.13056d26.svg";